import "./partnerslanding.css";
import TinyTitle from "../../../components/tinytitle/TinyTitle";
import { useNavigate } from "react-router-dom";
import imagePartner from '../../../assets/images/Sharepass-partner.png'

const PartnersLanding = ({title, para, image}) => {
    const navigate = useNavigate();
    const becomePartner = () =>{
        navigate('/becomepartner');
    };
    return(
        <section className="partners">
            <div className="content_sec">
                <div className="bi_grid">
                    <div className="text">
                        <TinyTitle title="PARTNERS" textcolor="#fff" />
                        <h1>Partnering with Excellence</h1>
                        <p className="para">SharePass recognizes that forging strong alliances is pivotal to crafting a safer digital landscape. Hence, we've allied with top-tier industry frontrunners united by our mutual dedication to data privacy and protection. Together, we're dedicated to delivering unparalleled data security solutions.</p>
                        <button type='button' className="second" onClick={becomePartner} >
                            Become a Partner
                        </button>
                    </div>
                    <div className="img">
                    <img src={imagePartner} alt='landing'></img>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default PartnersLanding;